(() => {
	const startSlider = (el) => {
		if ($(el).hasClass("slider_started")) return;
		$(el).addClass("slider_started");
		const deferred = el.querySelector("template[data-deferred-slides]");
		if (deferred) {
			deferred.replaceWith(deferred.content);
			if (typeof checkSwatches === "function") checkSwatches();
		}
		let id = $(el).attr("id");
		let slideEl = $(el).find(".swiper-wrapper");
		let productCount = parseInt(slideEl.data("count"));
		let productCountMobile = parseInt(slideEl.data("count-mobile"));

		let prodSwiperParams = {
			loop: false,
			autoHeight: true,
			allowTouchMove: true,
			slidesPerView: productCountMobile,
			breakpoints: {
				576: { slidesPerView: Math.min(2, productCount) },
				750: { slidesPerView: Math.min(3, productCount) },
				1100: { slidesPerView: Math.min(4, productCount) },
				1360: { slidesPerView: Math.min(5, productCount) },
				1600: { slidesPerView: Math.min(6, productCount) },
			},
			lazy: true,
			preloadImages: false,
			spaceBetween: 24,
			navigation: {
				nextEl: `#${id} .swiper-button-next`,
				prevEl: `#${id} .swiper-button-prev`,
			},
		};

		let initProductCarouselSliders = new Swiper(
			`#${id} .product-carousel-swiper`,
			prodSwiperParams
		);
		const refreshSlider = () => {
			initProductCarouselSliders.update();
			initProductCarouselSliders.navigation.update();
		};
		if (document.readyState === "complete") {
			refreshSlider();
		} else {
			window.addEventListener("load", refreshSlider);
		}
	};

	const observer = "IntersectionObserver" in window
		? new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				observer.unobserve(entry.target);
				startSlider(entry.target);
			});
		}, { rootMargin: "300px 0px" })
		: null;

	let initProductCarouselSliders = () => {
		$(".product-carousel-section").each(function () {
			if (observer && !(window.Shopify && Shopify.designMode)) observer.observe(this);
			else startSlider(this);
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductCarouselSliders();
	});

	initProductCarouselSliders();
})();
